<template>
    <v-alert dense text type="info" border="left" class="mb-0 text-left config-moved-notice">
        <div class="body-2 font-weight-medium">As configurações foram movidas para uma nova tela</div>
        <div class="caption">
            Acesse <strong>Painel de Controle › Configurações Gerais</strong><span v-if="card">, card <strong>{{ card }}</strong></span>.
        </div>
        <v-btn x-small text color="info" class="mt-1 px-1" @click.stop.prevent="goToNewScreen">
            Abrir nova tela <v-icon x-small right>mdi-open-in-new</v-icon>
        </v-btn>
    </v-alert>
</template>

<script>
export default {
    name: 'SysNoticeConfigMoved',
    props: {
        // Card da nova tela onde a configuração agora fica (opcional)
        card: {
            type: String,
            default: null,
        },
    },
    methods: {
        goToNewScreen() {
            this.$router.push({ name: 'general-settings' })
        },
    },
}
</script>
